import { bindActionCreators } from 'redux'
import { cognitoLoginError, cognitoLoginUser } from '../../actions'

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      cognitoLoginError,
      cognitoLoginUser
    },
    dispatch
  )

export default mapDispatchToProps
